// extracted by mini-css-extract-plugin
export default {"inputContainerUnique":"ArquivamentoSolic_inputContainerUnique__UQExu","descricao":"ArquivamentoSolic_descricao__XXFPs","divPrincipal":"ArquivamentoSolic_divPrincipal__jg8-o"};